'use client';

import type { SearchMenuTableFeatures } from '@morpho-org/ui-v6/client';
import type { ColumnDefWithSkeleton } from '@morpho-org/ui-v6/types';
import { CellTokenPrice, MarketCell } from '@morpho-org/ui-v6/client';
import { Icon } from '@repo/ui';
import { Check } from '@repo/ui/icons';
import CellNetApy from '@/components/common/Cells/CellNetApy';
import { WarningIcon } from '@/components/common/WarningIcon';
import type { SelectMarketRow } from './SelectMarket.types';
export const selectMarketColumns: ColumnDefWithSkeleton<SearchMenuTableFeatures, SelectMarketRow>[] = [{
  id: 'market',
  header: () => <span className="text-3xs text-secondary-foreground" style={{
    marginLeft: '12px'
  }}>
        Market
      </span>,
  cell: function Cell({
    row
  }) {
    return <div className="gap-xs flex min-w-0 items-center" data-testid={`market-cell-${row.original.market.marketId.toLowerCase()}`}>
          <MarketCell className="min-w-0" collateralAsset={row.original.market.collateralAsset} loanAsset={row.original.market.loanAsset} lltv={row.original.market.lltv} renderWarnings={<WarningIcon warnings={row.original.market.warnings} />} truncateSymbols />
          {row.original.isSelected && <Icon className="text-foreground" icon={<Check />} />}
        </div>;
  },
  accessorFn: row => row.market.lltv
}, {
  id: 'liquidity',
  header: 'Liquidity',
  cell: ({
    row
  }) => {
    if (!row.original.loanAsset) {
      return null;
    }
    return <CellTokenPrice withAvatar token={row.original.loanAsset} amount={row.original.liquidity.amount} maxLength={6} amountClassName="text-3xs" value={row.original.liquidity.value} />;
  },
  accessorFn: row => row.market.state?.liquidityAssetsUsd
}, {
  id: 'netApy',
  header: 'Rate',
  accessorFn: row => row.netApy.avgNetBorrowApy,
  cell: ({
    row
  }) => {
    if (!row.original.netApy.avgBorrowApy) return null;
    if (!row.original.netApy.avgNetBorrowApy) return null;
    return <CellNetApy variant="market" performanceFee={BigInt(0)} netApy={row.original.netApy.avgNetBorrowApy} apy={row.original.netApy.avgBorrowApy} rewards={row.original.netApy.rewards} points={row.original.netApy.points} textClassName="text-3xs" isHoverable={false} />;
  }
}];
export const mobileSelectMarketColumns: ColumnDefWithSkeleton<SearchMenuTableFeatures, SelectMarketRow>[] = [{
  id: 'market',
  header: 'Market',
  cell: ({
    row
  }) => {
    return <div className="gap-xs flex flex-row flex-wrap items-center" style={{
      marginBlock: '12px'
    }}>
          <MarketCell collateralAsset={row.original.market.collateralAsset} loanAsset={row.original.market.loanAsset} lltv={row.original.market.lltv} renderWarnings={<WarningIcon warnings={row.original.market.warnings} />} truncateSymbols />
          {row.original.loanAsset && <CellTokenPrice withAvatar token={row.original.loanAsset} amount={row.original.liquidity.amount} value={row.original.liquidity.value} />}
          <CellNetApy netApy={row.original.netApy.avgNetBorrowApy} apy={row.original.netApy.avgBorrowApy} performanceFee={BigInt(0)} rewards={row.original.netApy.rewards} variant="market" isHoverable={false} />
        </div>;
  }
}];